export const defaultConfirmText = 'Confirm & Save';
